import apiClient from "./config";
import { MENTORSHIP_ENDPOINTS } from "./endpoints";

const mentorshipService = {
  getMentors: () => {
    return apiClient.get(MENTORSHIP_ENDPOINTS.MENTORS);
  },
  getAvailability: (mentorId) => {
    return apiClient.get(
      `${MENTORSHIP_ENDPOINTS.MENTORS}/${mentorId}/availability`,
    );
  },
  // Returns { url } — the Stripe Checkout page to send the nurse to.
  bookMentor: (mentorId, payload) => {
    return apiClient.post(
      `${MENTORSHIP_ENDPOINTS.MENTORS}/${mentorId}/book`,
      payload,
    );
  },
  confirmBooking: (sessionId) => {
    return apiClient.get(MENTORSHIP_ENDPOINTS.CONFIRM_BOOKING, {
      params: { session_id: sessionId },
    });
  },
};

export default mentorshipService;
